import { clientId, lpRequest } from '../../../../core/api/lp-request';
import { getDriver } from '../../../drivers/data/datasources/get-driver';

export const removeDriverFromHub = async (
  promisor_id: string,
  contract_id: string,
  driver_id: string,
  hub_id: string
): Promise<any> => {
  await lpRequest(`/fleet/${clientId()}/fleet/bulk-driver-assign`, {
    method: 'POST',
    body: { assign: false, driver_ids: [driver_id], hub_id, promisor_id }
  });

  return getDriver(driver_id);
};
